import { __assign, __rest } from "tslib";
import React from 'react';
import VeltVideoPlayerControlsSubtitleButtonIconWireframe from './VeltVideoPlayerControlsSubtitleButtonIconWireframe/VeltVideoPlayerControlsSubtitleButtonIconWireframe';
import VeltVideoPlayerControlsSubtitleButtonTooltipWireframe from './VeltVideoPlayerControlsSubtitleButtonTooltipWireframe/VeltVideoPlayerControlsSubtitleButtonTooltipWireframe';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltVideoPlayerControlsSubtitleButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-subtitle-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerControlsSubtitleButtonWireframe.Icon = VeltVideoPlayerControlsSubtitleButtonIconWireframe;
VeltVideoPlayerControlsSubtitleButtonWireframe.Tooltip = VeltVideoPlayerControlsSubtitleButtonTooltipWireframe;
export default VeltVideoPlayerControlsSubtitleButtonWireframe;
